import { useFormik } from 'formik';
import { initialValues } from './formData';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../services/param.service';
import { Motive } from '../../../../../shared/types/systemConfiguration/motives';

export const useMotiveFilters = (onFilter?: (data: Motive) => void) => {
    const [types, setTypes] = useState<ISelect[]>([]);

    const onSubmit = (data: Motive) => {
        if (onFilter) onFilter(data || {});
    };

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_TYPE).then((params) =>
            setTypes(
                params.map((param) => ({ id: param?.id, name: param?.name }))
            )
        );
    }, []);

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    return {
        formik,
        types,
    };
};
